package org.braunequip.web.pages.braunadmin

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaGoogle
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.launch
import org.braunequip.web.styles.noBorder
import org.braunequip.web.util.*
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button

@Page
@Composable
fun LoginAdminPage() {
    //TODO check if logged in
    LoginAdminScreen()
}

@Composable
fun LoginAdminScreen() {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    var errorText by remember { mutableStateOf(" ") }

    //Represents whole screen
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .padding(leftRight = 50.px, top = 80.px, bottom = 24.px)
                .backgroundColor(Theme.LightGray.rgb),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                modifier = Modifier
                    .margin(bottom = 50.px)
                    .fillMaxWidth(),
                src = Res.Image.logo,
                description = "Logo Image"
            )

            //Sign In
            Button(
                attrs = Modifier
                    .margin(bottom = 24.px)
                    .width(350.px)
                    .height(54.px)
                    .backgroundColor(Theme.Primary.rgb)
                    .color(Colors.White)
                    .fontFamily(FONT_FAMILY2)
                    .fontWeight(FontWeight.Medium)
                    .fontSize(18.px)
                    .borderRadius(r = 4.px)
                    .noBorder()
                    .cursor(Cursor.Pointer)
                    .onClick {
                        scope.launch {
                            console.log("Attempting Google log-in!")
                            routeToAuthLogin(context)
                        }
                    }
                    .toAttrs()
            ) {
                FaGoogle(
                    modifier = Modifier
                        .color(Colors.White)
                        .margin(right = 10.px),
                    size = IconSize.XL
                )
                SpanText(text = "Braun Google")
            }

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .fontFamily(FONT_FAMILY)
                    .color(Colors.Red)
                    .textAlign(TextAlign.Center),
                text = errorText
            )

        }
    }
}